import React, { ReactElement, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Article, Business, Groups, InsertLink } from '@mui/icons-material';
import RouterGuard from './router-guard';
import MainLayout from '../main-layout';

export type CustomRouteObject = Omit<RouteObject, 'children'> & {
  title?: string;
  hidden?: boolean;
  meta?: {
    icon?: ReactElement;
    name?: string;
    type?: string;
    validToken?: boolean;
  };
  children?: Array<CustomRouteObject>;
  index?: false;
};

const Login = lazy(() => import('../pages/login'));
const Order = lazy(() => import('../pages/order'));
const CompanyManagement = lazy(() => import('../pages/company'));
const DispatchCorrelation = lazy(() => import('../pages/dispatch-correlation'));
const Driver = lazy(() => import('../pages/driver'));
const UserManage = lazy(() => import('../pages/system/user'));
const RoleManage = lazy(() => import('../pages/system/role'));

export const routes: CustomRouteObject[] = [
  {
    path: '/',
    element: <RouterGuard element={<MainLayout />} valid={true} />,
    children: [
      {
        title: '運單管理',
        path: '/order',
        element: <Order />,
        meta: { icon: <Article />, validToken: true, name: 'ORDER' },
      },
      {
        title: '司機管理',
        path: '/driver',
        element: <Driver />,
        meta: { icon: <Groups />, validToken: true, name: 'DRIVERMANAGEMENT' },
      },
      {
        title: '公司管理',
        path: '/company',
        meta: { icon: <Business />, validToken: true },
        children: [
          {
            title: '公司數據',
            path: 'list',
            element: <CompanyManagement />,
            meta: { icon: <Business />, validToken: true, name: 'ORGANIZATION' },
          },
          {
            title: '派單關聯',
            path: 'delegation',
            element: <DispatchCorrelation />,
            meta: { icon: <InsertLink />, validToken: true, name: 'ORGANIZATION' },
          },
        ],
      },
      {
        title: '系统设置',
        path: '/system',
        meta: { icon: <Article />, validToken: true },
        children: [
          {
            title: '用户管理',
            path: 'user',
            element: <UserManage />,
            meta: { icon: <Article />, validToken: true, name: 'SETTING.USER' },
          },
          {
            title: '角色管理',
            path: 'role',
            element: <RoleManage />,
            meta: { icon: <Article />, validToken: true, name: 'SETTING.ROLE' },
          },
        ],
      },
    ],
  },
  { path: '/login', element: <Login /> },
  { path: '/404', element: <div>404</div> },
];
